export default "__VITE_ASSET__Bpd7jTj6__"